import React from 'react'
import { useParams } from 'react-router';
import APIS from '../../constant/EndPoint';
import useGetHook from '../../customHooks/useGetHook';
import loadable from '@loadable/component';
import CreateIcon from '../../Icons/Create';

const InvoicePreviewComponent = loadable(
  () => import("../../components/Finance/InvoicePreview")
);

const InvoicePreview = () => {
  const { id } = useParams()

  const { data: order } = useGetHook({
    queryKey: ["City"],
    url: `${APIS.INVOICE}${id}/`,
    params: {},
  });

  const { data: businessProfile } = useGetHook({
    queryKey: [`business-profile`],
    url: `${APIS.BUSINESS_PROFILE}`,
    params: {},
  });

  return (
    <>
      <div className="w-full flex justify-left gap-x-2 mb-6 uppercase font-extrabold items-center">
        <CreateIcon />
        <span className="text-[#5E5757] font-bold text-xl">
          Invoice Preview
        </span>
      </div>
      <InvoicePreviewComponent
        businessProfile={businessProfile?.[0]}
        order={order}
      />
    </>

  )
}

export default InvoicePreview
